import { action, makeObservable, observable } from 'mobx';

import { Model } from './Model';

export interface IAnnouncementCategoryModel {
    id?: number;
    name?: string;
    image?: string;
    color?: string;
}

export class AnnouncementCategoryModel extends Model implements IAnnouncementCategoryModel {
    id = 0;
    name = '';
    image = '';
    color = '';

    constructor(payload: IAnnouncementCategoryModel = {}) {
        super();

        makeObservable(this, {
            id: observable,
            name: observable,
            image: observable,
            color: observable,
            update: action,
        });

        this.update(payload);
    }
}
